import { useTranslation } from "react-i18next";

import {
  createLADSAutomation,
  deleteLADSAutomation,
  updateLADSAutomation,
} from "../api/lads";
import { useAutomations } from "../hooks/use-automations";
import { useFumehoods } from "../hooks/use-devices";
import { ErrorScreenWithText } from "../partials/error-screen";
import { LoadingScreenWithText } from "../partials/loading-screen";
import { PagePartial } from "../partials/page-partial";
import { TimeControlPagePartial } from "../partials/time-control-page";

export const TimeControlPage = () => {
  const { t } = useTranslation();
  const { devices, error, isLoading } = useFumehoods();

  const {
    automations,
    isLoading: isLoadingAutomations,
    mutate,
  } = useAutomations();

  if (isLoading || isLoadingAutomations) return <LoadingScreenWithText />;

  if (error) return <ErrorScreenWithText error={error} />;

  return (
    <PagePartial title={t("page.timecontrol")}>
      <TimeControlPagePartial
        automations={automations}
        createAutomation={createLADSAutomation}
        deleteAutomation={deleteLADSAutomation}
        devices={devices}
        mutateAutomations={mutate}
        updateAutomation={updateLADSAutomation}
      />
    </PagePartial>
  );
};
